export const LOAD_SNAPSHOT_REQUEST = "LOAD_SNAPSHOT_REQUEST";
export const LOAD_SNAPSHOT_SUCCESS = "LOAD_SNAPSHOT_SUCCESS";
export const LOAD_SNAPSHOT_FAILURE = "LOAD_SNAPSHOT_FAILURE";
export const UPDATE_SNAPSHOT = "UPDATE_SNAPSHOT";